module.exports = __webpack_public_path__ + "4840ae8980e0f778562c46fbaf7a2cff.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/above-the-fold-mobile-new-bg.jpg
// module id = ./app/images/above-the-fold-mobile-new-bg.jpg
// module chunks = 35